import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function usePageTracking(gaId = "G-XXXXXXXXXX") {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;

    // Google Analytics page view
    if (typeof window.gtag === "function" && gaId) {
      window.gtag("config", gaId, { page_path: path });
    }

    // Meta Pixel page view
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location, gaId]);
}
